import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'ka', label: 'ქართული', flag: '🇬🇪' },
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(i18n.language || 'en');
  const ref = useRef(null);

  // load persisted language
  useEffect(() => {
    const saved = localStorage.getItem('lng');
    if (saved && saved !== i18n.language) {
      i18n.changeLanguage(saved);
      setCurrent(saved);
    }
  }, [i18n]);

  // close on outside click / Esc
  useEffect(() => {
    function onDocClick(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    function onEsc(e) { if (e.key === 'Escape') setOpen(false); }
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => { document.removeEventListener('click', onDocClick); document.removeEventListener('keydown', onEsc); };
  }, []);

  const cur = LANGS.find(l => l.code.startsWith(current)) || LANGS[0];

  function select(lng) {
    i18n.changeLanguage(lng);
    setCurrent(lng);
    localStorage.setItem('lng', lng);
    setOpen(false);
  }

  return (
    <div className="langsel" ref={ref}>
      <button
        className="langsel-btn"
        onClick={() => setOpen(v => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        title={`${cur.label} (${cur.code.toUpperCase()})`}
      >
        <span className="flag">{cur.flag}</span>
        <span className="code">{cur.code.toUpperCase()}</span>
        <span className="chev">▾</span>
      </button>

      {open && (
        <div className="langsel-menu" role="menu">
          {LANGS.map(l => (
            <button
              key={l.code}
              className={`langsel-item ${l.code === cur.code ? 'is-active' : ''}`}
              onClick={() => select(l.code)}
              role="menuitem"
            >
              <span className="flag">{l.flag}</span>
              <span className="label">{l.label}</span>
              <span className="code">{l.code.toUpperCase()}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
